const baseURL = "https://us-central1-expirytracker-app.cloudfunctions.net/app/";
const googleRecaptchaBaseURL = "https://www.google.com/";
export { baseURL, googleRecaptchaBaseURL };
